export const subscriptionOptions = [
  {
    information: {
      name: 'Mixed',
      abr: 'mixed',
      icon: 'https://cdn.proxyscrape.com/img/country/mixed.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'mixed',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'mixed',
      },
      {
        title: '5000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=5000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'mixed',
      },
      {
        title: '7500',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=7500',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'mixed',
      },
      {
        title: '10 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=10000',
        imgUrl: require('../assets/img/premium/svg/plan5.svg'),
        abr: 'mixed',
      },
      {
        title: '15 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=15000',
        imgUrl: require('../assets/img/premium/svg/plan6.svg'),
        abr: 'mixed',
      },
      {
        title: '20 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=20000',
        imgUrl: require('../assets/img/premium/svg/plan7.svg'),
        abr: 'mixed',
      },
      {
        title: '25 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=25000',
        imgUrl: require('../assets/img/premium/svg/plan8.svg'),
        abr: 'mixed',
      },
      {
        title: '30 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=30000',
        imgUrl: require('../assets/img/premium/svg/plan9.svg'),
        abr: 'mixed',
      },
      {
        title: '40 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=40000',
        imgUrl: require('../assets/img/premium/svg/plan10.svg'),
        abr: 'mixed',
      },
      {
        title: '50 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=50000',
        imgUrl: require('../assets/img/premium/svg/plan11.svg'),
        abr: 'mixed',
      },
      {
        title: '60 000',
        url: '/purchase?type=new_datacenter_shared&proxies[mixed]=60000',
        imgUrl: require('../assets/img/premium/svg/plan12.svg'),
        abr: 'mixed',
      },
    ],
  },
  {
    information: {
      name: 'United States',
      abr: 'us',
      icon: 'https://cdn.proxyscrape.com/img/country/us.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'us',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'us',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'us',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'us',
      },
      {
        title: '5000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=5000',
        imgUrl: require('../assets/img/premium/svg/plan5.svg'),
        abr: 'us',
      },
      {
        title: '6000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=6000',
        imgUrl: require('../assets/img/premium/svg/plan6.svg'),
        abr: 'us',
      },
      {
        title: '7000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=7000',
        imgUrl: require('../assets/img/premium/svg/plan7.svg'),
        abr: 'us',
      },
      {
        title: '8000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=8000',
        imgUrl: require('../assets/img/premium/svg/plan8.svg'),
        abr: 'us',
      },
      {
        title: '9000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=9000',
        imgUrl: require('../assets/img/premium/svg/plan9.svg'),
        abr: 'us',
      },
      {
        title: '10 000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=10000',
        imgUrl: require('../assets/img/premium/svg/plan10.svg'),
        abr: 'us',
      },
      {
        title: '15000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=15000',
        imgUrl: require('../assets/img/premium/svg/plan11.svg'),
        abr: 'us',
      },
      {
        title: '20 000',
        url: '/purchase?type=new_datacenter_shared&proxies[us]=20000',
        imgUrl: require('../assets/img/premium/svg/plan12.svg'),
        abr: 'us',
      },
    ],
  },
  {
    information: {
      name: 'Germany',
      abr: 'de',
      icon: 'https://cdn.proxyscrape.com/img/country/de.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[de]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'de',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[de]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'de',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[de]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'de',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[de]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'de',
      },
    ],
  },
  {
    information: {
      name: 'United Kingdom',
      abr: 'gb',
      icon: 'https://cdn.proxyscrape.com/img/country/gb.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[gb]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'gb',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[gb]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'gb',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[gb]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'gb',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[gb]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'gb',
      },
    ],
  },
  {
    information: {
      name: 'Brazil',
      abr: 'br',
      icon: 'https://cdn.proxyscrape.com/img/country/br.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[br]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'br',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[br]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'br',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[br]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'br',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[br]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'br',
      },
    ],
  },
  {
    information: {
      name: 'France',
      abr: 'fr',
      icon: 'https://cdn.proxyscrape.com/img/country/fr.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[fr]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'fr',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[fr]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'fr',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[fr]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'fr',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[fr]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'fr',
      },
    ],
  },
  {
    information: {
      name: 'India',
      abr: 'in',
      icon: 'https://cdn.proxyscrape.com/img/country/in.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[in]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'in',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[in]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'in',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[in]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'in',
      },
    ],
  },
  {
    information: {
      name: 'Thailand',
      abr: 'th',
      icon: 'https://cdn.proxyscrape.com/img/country/th.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[th]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'th',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[th]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'th',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[th]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'th',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[th]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'th',
      },
    ],
  },
  {
    information: {
      name: 'Canada',
      abr: 'ca',
      icon: 'https://cdn.proxyscrape.com/img/country/ca.png',
    },
    cards: [
      {
        title: '1000',
        url: '/purchase?type=new_datacenter_shared&proxies[ca]=1000',
        imgUrl: require('../assets/img/premium/svg/plan1.svg'),
        abr: 'ca',
      },
      {
        title: '2500',
        url: '/purchase?type=new_datacenter_shared&proxies[ca]=2500',
        imgUrl: require('../assets/img/premium/svg/plan2.svg'),
        abr: 'ca',
      },
      {
        title: '3000',
        url: '/purchase?type=new_datacenter_shared&proxies[ca]=3000',
        imgUrl: require('../assets/img/premium/svg/plan3.svg'),
        abr: 'ca',
      },
      {
        title: '4000',
        url: '/purchase?type=new_datacenter_shared&proxies[ca]=4000',
        imgUrl: require('../assets/img/premium/svg/plan4.svg'),
        abr: 'ca',
      },
    ],
  },
];
